import Organization from "../../../views/guides/GOrganization";
import { settingConstants } from "../../constants/SettingConstants";

const defaultState = {
  settings: {},
  loading: false,
  fetched: false,
  error: null
};

// Функция для нормализации элементов blockPeriod
function normalizeBlockPeriods(blockPeriods) {
  if (!Array.isArray(blockPeriods)) return [];

  return blockPeriods.map((item, index) => ({
    ...item,
    itemId: item.id,
    organization: item.organization.nameOrganization,
    organizationId: item.organization.id,
    dateBlock: item?.dateBlock?.split('T')[0] ?? null,
  }));
}

export const settingReducer = function (state = defaultState, action) {
  switch (action.type) {
    case settingConstants.GET_REQUEST_SETTING:
      return {
        ...state,
        loading: true,
        fetched: false,
        error: null
      };
    case settingConstants.GET_SUCCESS_SETTING:
      return {
        ...state,
        settings: {
          ...action.response,
          ...(action.response.blockPeriod && {
            blockPeriod: normalizeBlockPeriods(action.response.blockPeriod)
          })
        },
        loading: false,
        fetched: true,
      };
    case settingConstants.GET_FAILURE_SETTING:
      return {
        ...state,
        loading: false,
        fetched: false,
        error: action.error,
      };
    case settingConstants.CREATE_REQUEST_SETTING:
      return {
        ...state,
        loading: true,
        fetched: false,
        error: null
      };
    case settingConstants.CREATE_SUCCESS_SETTING:
      return {
        ...state,
        loading: false,
        fetched: true,
        settings: {
          ...action.response,
          ...(action.response.blockPeriod && {
            blockPeriod: normalizeBlockPeriods(action.response.blockPeriod)
          })
        },
      };
    case settingConstants.CREATE_FAILURE_SETTING:
      return {
        ...state,
        loading: false,
        fetched: false,
        error: action.error,
      };
    case settingConstants.UPDATE_REQUEST_SETTING:
      return {
        ...state,
        loading: true,
        fetched: false,
        error: null
      };
    case settingConstants.UPDATE_SUCCESS_SETTING:
      return {
        ...state,
        loading: false,
        fetched: true,
        settings: {
          ...action.response,
          ...(action.response.blockPeriod && {
            blockPeriod: normalizeBlockPeriods(action.response.blockPeriod)
          })
        },
      };
    case settingConstants.UPDATE_FAILURE_SETTING:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: false,
        error: action.error,
      };
    default:
      return state;
  }
}
